module.exports = __webpack_public_path__ + "img/full7-min.1ec924b1.png";